const headers = [{
    text: "Código do Orçamento",
    align: "left",
    sortable: true,
    value: "code"
  },
  {
    text: "Empresa",
    align: "center",
    value: "company"
  },
  {
    text: "Tipo do Orçamento",
    align: "center",
    value: "tradingFloor"
  },
  {
    text: "Processo",
    align: "center",
    value: "process"
  },
  {
    text: "Cliente",
    align: "center",
    value: "client"
  },
  {
    text: "Data do Pregão",
    align: "center",
    value: "dateOfTheTradingFloor"
  },
  {
    text: "Situação",
    align: "center",
    value: "situation"
  },
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]

class Headers {
  static getHeaders() {
    return headers
  }
}
export default Headers;



// WEBPACK FOOTER //
// ./src/data/headers/BudgetHeaders.js